import React from "react";
import FullFareRulesLink from "./FullFareRulesLink";
import GovtIssuedIDLink from "./GovtIssuedIDLink";
import "./styles.css";

const ImportantInformation = ({ fareRules }) => (
  <div>
    <h6 class="important-info__header"> Important Information </h6>
    <ul class="important-info__body">
      <li>
        Once confirmed, airline change penalties and restrictions apply. Most
        tickets are non-refundable. See your airline’s <FullFareRulesLink fareRules={fareRules} />{" "}
        here.
      </li>
      <li>
        Airline tickets are non-transferrable. Name changes or adjustments are
        not allowed once purchased.
      </li>
      <li>
        Airfares and flight availability are not guaranteed until purchased.
      </li>
      <li>
        Domestic / International Flights:
        <ul>
          <li>
            Domestic: You will be issued electronic tickets. Remember to bring a
            valid <GovtIssuedIDLink /> with you to check-in.
          </li>
          <li>
            International: You will be issued electronic tickets. All travelers
            will need a valid passport and you may also need to show additional
            documentation at your destination and/or in connecting countries.
          </li>
        </ul>
      </li>
      {/* <li>
        Trip Protection  ○ You added
        Trip Protection. View Description of Coverage, which includes full terms
        and conditions.
      </li> */}
    </ul>
  </div>
);

export default ImportantInformation;



// WEBPACK FOOTER //
// ./src/components/ImportantInformation/index.js